import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MessageCircle } from 'lucide-react';

/**
 * Footer Component
 * 
 * Clones the footer section of BASUPRA EXIM website based on design instructions:
 * - Contact address on the left
 * - Navigation menus in the center
 * - Contact links on the right
 * - Copyright bar at the bottom
 * - Floating support button and catalogue teaser
 */

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-white font-body pt-[80px]">
      {/* Black Divider Section as seen in screenshots */}
      <div className="w-full h-[150px] bg-black mb-[60px]"></div>

      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-16">
          
          {/* Left Column: Contact Address */}
          <div className="flex flex-col space-y-4">
            <div className="text-[#1E73BE] font-display font-semibold text-[16px] leading-[1.6]">
              <p>M/s Basupra Exim International</p>
              <p>Plot No 162 Industrial Estate,</p>
              <p>Palus. Dist- Sangli, Maharashtra.</p>
              <p>India, Pin 416310</p>
            </div>
            <div className="flex items-center space-x-6 pt-4">
              <a href="tel:+919890527244" className="text-[#1E73BE] hover:opacity-80 transition-opacity">
                <Phone size={18} />
              </a>
              <a href="mailto:info@basupraexim.com" className="text-[#1E73BE] hover:opacity-80 transition-opacity">
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Center Column: Menu */}
          <div className="flex flex-col">
            <h3 className="font-display font-bold text-[18px] text-[#001D3D] mb-6">Menu</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#4A5568] hover:text-[#1E73BE] text-[15px] transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-[#4A5568] hover:text-[#1E73BE] text-[15px] transition-colors">About</Link>
              </li>
              <li>
                <Link to="/projects" className="text-[#4A5568] hover:text-[#1E73BE] text-[15px] transition-colors">Projects</Link>
              </li>
            </ul>
          </div>

          {/* Right Column: Contact/Services Links */}
          <div className="flex flex-col">
            <h3 className="font-display font-bold text-[18px] text-[#001D3D] mb-6">Contact</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-[#4A5568] hover:text-[#1E73BE] text-[15px] transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#4A5568] hover:text-[#1E73BE] text-[15px] transition-colors">Contact</Link>
              </li>
              <li>
                <Link to="/downloads" className="text-[#4A5568] hover:text-[#1E73BE] text-[15px] transition-colors">Downloads</Link>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Copyright Bar */}
      <div className="w-full border-t border-[#E2E8F0] py-6">
        <div className="container mx-auto px-4 max-w-[1200px] flex justify-center items-center">
          <p className="text-[#4A5568] text-[14px]">
            Copyright © {currentYear} BASUPRA EXIM | Developed by ATPL
          </p>
        </div>
      </div>

      {/* Floating Support & Catalogue Elements */}
      <div className="fixed bottom-6 right-6 flex items-center space-x-2 z-50">
        <div className="hidden md:flex items-center bg-white shadow-lg border border-[#E2E8F0] px-4 py-2 rounded-full cursor-pointer hover:bg-gray-50 transition-colors">
          <span className="text-[#4A5568] text-[14px] font-medium mr-2">Download Catalogue</span>
        </div>
        <div className="bg-[#1E73BE] p-3 rounded-full shadow-lg cursor-pointer hover:bg-[#1660a1] transition-colors">
          <MessageCircle className="text-white" size={24} />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
